import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Inscriptions from "@/pages/Inscriptions";
import Offres from "@/pages/Offres";
import Competitions from "@/pages/Competitions";
import Actualites from "@/pages/Actualites";
import ActualiteDetail from "@/pages/ActualiteDetail";
import Galerie from "@/pages/Galerie";
import Evenements from "@/pages/Evenements";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ProtectedRoute({ children }) {
    const { user, ready } = useAuth();
    if (!ready) return <div className="min-h-screen grid place-items-center font-mono text-sm text-slate-500">Chargement…</div>;
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-center" richColors />
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/inscriptions" element={<Inscriptions />} />
                            <Route path="/offres" element={<Offres />} />
                            <Route path="/cours" element={<Navigate to="/offres" replace />} />
                            <Route path="/competitions" element={<Competitions />} />
                            <Route path="/evenements" element={<Evenements />} />
                            <Route path="/actualites" element={<Actualites />} />
                            <Route path="/actualites/:id" element={<ActualiteDetail />} />
                            <Route path="/galerie" element={<Galerie />} />
                            <Route path="/contact" element={<Contact />} />
                        </Route>
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute>
                                    <AdminDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
